import React from "react";
import { FiExternalLink, FiCheck, FiX } from "react-icons/fi";
import styles from "./PresetPreviewModal.module.css";

/**
 * PresetPreviewModal — full-screen modal with iframe showing the storefront
 * rendered in a specific template + preset combination. Lets the seller
 * eyeball the full look before activating.
 */
function PresetPreviewModal({ templateName, presetName, presetLabel, isActivating, onClose, onActivate }) {
    const previewUrl = `/template-preview/${templateName}?preset=${encodeURIComponent(presetName)}`;

    return (
        <div className={styles.backdrop} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <header className={styles.header}>
                    <div>
                        <div className={styles.headerTitle}>{presetLabel || presetName}</div>
                        <div className={styles.headerSubtitle}>
                            Preview of the <strong>{templateName}</strong> template with <strong>{presetName}</strong> colors
                        </div>
                    </div>
                    <div className={styles.actions}>
                        <a
                            href={previewUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.openNewBtn}
                        >
                            <FiExternalLink /> Open in new tab
                        </a>
                        {onActivate && (
                            <button
                                className={styles.activateBtn}
                                onClick={onActivate}
                                disabled={isActivating}
                            >
                                {isActivating ? "Activating…" : <><FiCheck /> Use this preset</>}
                            </button>
                        )}
                        <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
                            <FiX />
                        </button>
                    </div>
                </header>
                <div className={styles.iframeWrap}>
                    <iframe
                        src={previewUrl}
                        title={`${templateName} · ${presetName}`}
                        className={styles.iframe}
                    />
                </div>
            </div>
        </div>
    );
}

export default PresetPreviewModal;
